import {Outlet, useLocation} from 'react-router'
import {TabBar} from './components/tab-bar/tab-bar.jsx'
import {ToastHost} from './components/toast/toast.jsx'
import {useAuth} from './auth/use-auth.js'
import {useForegroundNotifications} from './hooks/use-foreground-notifications.js'

export function AppShell() {
    const {pathname} = useLocation()
    const {user, status} = useAuth()
    const hideTabBar = pathname.startsWith('/auth') || status !== 'authed'
    const hideScenarios = !user?.roles?.admin

    useForegroundNotifications()

    return (
        <div className="app-shell">
            <main style={{flex: 1, paddingBottom: hideTabBar ? 0 : 'var(--tabbar-safe)'}}>
                <Outlet/>
            </main>
            {!hideTabBar && <TabBar hideScenarios={hideScenarios}/>}
            <ToastHost/>
        </div>
    )
}
